import * as React from 'react';
import { TLocalizationContext } from './LocalizationContext.types';
import { useAppDispatch, useAppSelector } from 'store/store';
import { getLocalizationList } from 'store/localization/localization.action';
import { Loader } from 'components';

const LocalizationContext = React.createContext<
  TLocalizationContext | undefined
>(undefined);

export const LocalizationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const { translations, locale } = useAppSelector(
    (state) => state.localization.localization.data
  );

  React.useEffect(() => {
    dispatch(getLocalizationList());
  }, [dispatch, locale]);

  const localize = React.useCallback(
    (key: string, dynamicValues?: Array<string>) => {
      const value = translations?.[key];

      if (!value) {
        return <Loader skeleton />;
      }
      if (!dynamicValues) return value;

      let result = value;
      dynamicValues.forEach((val) => {
        result = result.replace('${}', val);
      });
      return result;
    },
    [translations]
  );

  return (
    <LocalizationContext.Provider value={localize}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalize = (): TLocalizationContext => {
  const context = React.useContext(LocalizationContext);
  if (!context) {
    throw new Error('useLocalization must be used within LocalizationProvider');
  }
  return context;
};
